var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5714 0.81226H8.35714L8.10536 0.337456C8.05202 0.235947 7.96986 0.150561 7.86812 0.0909021C7.76638 0.0312432 7.6491 -0.000321023 7.52946 -0.000239689H4.46786C4.34849 -0.000674644 4.23142 0.0307719 4.13004 0.0904972C4.02866 0.150222 3.94708 0.235811 3.89464 0.337456L3.64286 0.81226H0.428571C0.314907 0.81226 0.205898 0.855062 0.125526 0.931248C0.0451529 1.00743 0 1.11077 0 1.21851L0 2.03101C0 2.13875 0.0451529 2.24209 0.125526 2.31827C0.205898 2.39446 0.314907 2.43726 0.428571 2.43726H11.5714C11.6851 2.43726 11.7941 2.39446 11.8745 2.31827C11.9548 2.24209 12 2.13875 12 2.03101V1.21851C12 1.11077 11.9548 1.00743 11.8745 0.931248C11.7941 0.855062 11.6851 0.81226 11.5714 0.81226ZM1.425 11.8572C1.44544 12.1666 1.58951 12.457 1.82787 12.6693C2.06624 12.8815 2.38098 12.9997 2.70804 12.9998H9.29196C9.61902 12.9997 9.93376 12.8815 10.1721 12.6693C10.4105 12.457 10.5546 12.1666 10.575 11.8572L11.1429 3.24976H0.857143L1.425 11.8572Z",
    fill: "#27509F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a88e61a0064d15290ddb5a8540a637c8.svg";
export { ForwardRef as ReactComponent };